import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { Splatter } from "@/components/Splatter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé");
      navigate("/connexion");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4 py-16">
      <Splatter />
      <div className="relative w-full max-w-md rounded-2xl border border-[#222] bg-[#0A0A0A]/90 backdrop-blur-xl p-8">
        <div className="text-center"><Logo className="text-2xl" /></div>
        <h1 className="mt-6 font-heading text-2xl font-bold text-center">Nouveau mot de passe</h1>
        {!token ? (
          <p className="mt-6 text-center text-gray-400">Lien invalide. <Link to="/mot-de-passe-oublie" className="text-[#E6007E]">Refaire une demande</Link></p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <div><Label>Nouveau mot de passe</Label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black border-white/15 mt-1" required minLength={6} /></div>
            {error && <p className="text-sm text-red-400">{error}</p>}
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="btn-primary w-full rounded-full py-6 font-bold">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Réinitialiser"}
            </Button>
          </form>
        )}
        <Link to="/connexion" className="mt-4 block text-center text-sm text-gray-400 hover:text-[#E6007E]">Retour à la connexion</Link>
      </div>
    </div>
  );
}
